module.exports = __webpack_public_path__ + "static/media/MC1@2x.297f8e47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/MC/MC1@2x.png
// module id = 691
// module chunks = 0